module.exports = __webpack_public_path__ + "img/conny-stage1-sulking.666ff941.png";